import React, { useMemo, useState } from 'react'
import { GeneralCardDetails } from '../atoms/GeneralCardDetails'
import { BalanceCardDetails } from '../atoms/BalanceCardDetails'
import { Flex, Tag, Typography } from 'antd'
import { GatewaysDetails } from '../atoms/GatewaysDetails/component'
import { TransactionsDetails } from '../atoms/TransactionsDetails/component'
import {
  CBreadcrumb,
  CBreadcrumbItem,
  CButton,
  CCol,
  CRow,
  CSpinner,
} from '@coreui/react-pro'
import { path, role } from '../../../../libs'
import { GeneralTransactionModal } from '../atoms/GeneralTransactionModal'
import { transactionsDetailsRefresh } from '../atoms/TransactionsDetails/model'
import { useWallet } from './hooks'
import { StatisticDetails } from '../atoms/StatisticDetails'
import { WalletStatus } from '../atoms/TransactionsDetails/const'
import { useStore } from 'effector-react'
import { $userRole } from '../../../../features/user'
import { RecalcModal } from '../atoms/RecalcModal'
import { DangerZone } from 'src/pages/finSystem/wallets/atoms/DangerZone'
import { isNull } from 'lodash'
import { Guard } from 'src/features/session/guard'
import { GUARD_RULES } from 'src/features/session/constants'

export const WalletDetails = () => {
  const { wallet, currencies, loadingWallet, inHold } = useWallet()
  const userRole = useStore($userRole)

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isRecalcModalOpen, setIsRecalcModalOpen] = useState(false)

  const showModal = () => {
    setIsModalOpen(true)
  }
  const showRecalcModal = () => {
    setIsRecalcModalOpen(true)
  }

  const currentWalletCurrencies = useMemo(
    () => wallet?.localBalances?.map((item) => item.currency),
    [wallet?.localBalances],
  )

  if (loadingWallet) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <CSpinner />
      </div>
    )
  }
  // Определите разрешенные роли для создания финансовых операций
  const allowedRoles = [
    role.head.ceo(),
    role.head.cmo(),
    role.head.cfo(),
    role.finSystem.finPO(),
    role.finances.seniorFinanceManager(),
    role.finances.leadFinanceManager(),
    role.finances.financeManager(),
  ]

  // Проверьте, имеет ли пользователь одну из разрешенных ролей
  const hasAccess = userRole && allowedRoles.some((r) => userRole.includes(r))
  const isArchived = !isNull(wallet.archivedAt)

  return (
    <>
      <CBreadcrumb>
        <CBreadcrumbItem href={path.finSystem.wallets.entry()}>
          Wallet
        </CBreadcrumbItem>
        <CBreadcrumbItem active>{wallet.name}</CBreadcrumbItem>
      </CBreadcrumb>
      <Flex justify="space-between">
        <Flex style={{ width: '50%' }} gap={24} align="center">
          <Typography.Title level={2} ellipsis={{ tooltip: wallet.name }}>
            {wallet.name}
          </Typography.Title>
          {isArchived && (
            <Tag style={{ marginBottom: 8 }} color="red-inverse">
              Archived
            </Tag>
          )}
        </Flex>
        <Flex gap={24}>
          {hasAccess && (
            <CButton
              color="primary"
              className="mb-2"
              size="sm"
              onClick={showModal}
              disabled={isArchived}
            >
              + Add new transaction
            </CButton>
          )}
          {(userRole?.includes(role.head.cfo()) ||
            userRole?.includes(role.finSystem.recalc())) && (
            <CButton
              color="warning"
              className="mb-2"
              size="sm"
              onClick={showRecalcModal}
            >
              Recalculate
            </CButton>
          )}
        </Flex>
      </Flex>
      <CRow className="mb-3">
        <CCol lg={12} xxl={7}>
          <CRow>
            <CCol xs={4} className="mb-3">
              <GeneralCardDetails
                id={wallet.id}
                currencies={currentWalletCurrencies}
              />
            </CCol>
            <CCol xs={8}>
              <BalanceCardDetails
                showInHold={wallet.name == 'KORA'} // @todo временное решение для одного кошелька, в дальнейшем переделать на параметр получаемый с апи
                inHold={inHold}
                overallBalanceUsd={wallet.overallBalanceUsd}
                localBalances={wallet.localBalances}
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol className="mb-lg-3">
              <GatewaysDetails paymentSystemId={wallet.paymentSystemId} />
            </CCol>
          </CRow>
        </CCol>
        <CCol lg={12} xxl={5}>
          <StatisticDetails currenciesFromWallet={currentWalletCurrencies} />
        </CCol>
      </CRow>
      <Guard permission={GUARD_RULES.VIEW_FIN_ALLOWED_WALLETS}>
        <CRow className="mb-3">
          <CCol>
            <DangerZone wallet={wallet} />
          </CCol>
        </CRow>
      </Guard>
      <CRow className="mb-3">
        <CCol>
          <TransactionsDetails
            currenciesFromWallet={currentWalletCurrencies}
            allCurrencies={currencies}
            walletStatus={WalletStatus.general}
            walletId={wallet.id}
          />
        </CCol>
      </CRow>
      <GeneralTransactionModal
        isOpen={isModalOpen}
        currenciesFromWallet={currentWalletCurrencies}
        allCurrencies={currencies}
        type="wallet"
        onClose={() => {
          setIsModalOpen(false)
          setTimeout(() => {
            transactionsDetailsRefresh()
          }, 1000)
        }}
      />
      <RecalcModal
        isOpen={isRecalcModalOpen}
        walletId={wallet.id}
        onClose={() => setIsRecalcModalOpen(false)}
      />
    </>
  )
}
